import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=f8c605de&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"
import style0 from "./survey.vue?vue&type=style&index=0&id=f8c605de&prod&lang=css"
import style1 from "./survey.vue?vue&type=style&index=1&id=f8c605de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c605de",
  null
  
)

export default component.exports